import { gql } from 'graphql-request'

export const UPLOAD_ARQUIVOS = gql`
  mutation UploadArquivosMutation($arquivos: [ItemBibliotecaInput!]!) {
    uploadArquivos(arquivos: $arquivos) {
      id
      nome
      pastaPai {
        id
      }
    }
  }
`
